import { uniq } from "~/utils/tsUtils"

import type { IVariantSummary } from "~/hooks/useVariantTableData"
import { createUniqueStringColumn } from "~/utils/columnTemplates"
import { ProductTableColumn } from "~/utils/productTableUtils"

import type { ColumnSpec } from "./types"

export interface CollectionColumnCtx {
  aggregations: string[]
  /** Set when the table is scoped to specific collections. */
  collectionIds: number[] | undefined
}

type CollectionSpec = ColumnSpec<IVariantSummary, CollectionColumnCtx>

/**
 * The collections a variant belongs to, narrowed to the table's scope. Non-numeric collection
 * ids are always kept, since a scope is expressed numerically.
 */
export function collectionNames(
  row: IVariantSummary,
  ctx: CollectionColumnCtx,
): string | string[] | undefined {
  if (ctx.aggregations.includes("Collection")) return row.groupCollection

  let collections = row.collections
  if (ctx.collectionIds && ctx.collectionIds.length > 0) {
    collections = collections?.filter((c) =>
      !isNaN(Number(c.id)) ? ctx.collectionIds!.includes(Number(c.id)) : true,
    )
  }
  return uniq(collections?.map((c) => c.name))
}

export const COLLECTION_COLUMN: CollectionSpec = {
  colId: ProductTableColumn.Collection,
  calculate: collectionNames,
  colDef: () =>
    createUniqueStringColumn<IVariantSummary>({
      colId: ProductTableColumn.Collection,
      field: "groupCollection",
      rowGroup: true,
      tooltipTitle: "Collections",
    }),
}

export const COLLECTION_COLUMN_SPECS: readonly CollectionSpec[] = [COLLECTION_COLUMN]
